import { z } from "zod";
export const REPORT_MAX_PHOTOS = 5;
export const REPORT_PDF_PREFLIGHT_MAX_BYTES = 5.5 * 1024 * 1024;
export const REPORT_PHOTO_MAX_BYTES = 240 * 1024;
export const REPORT_PHOTO_CAPTION_MAX_LENGTH = 500;
export const REPORT_PHOTO_CAPTION_MAX_NEWLINES = 8;
const reportPhotoDataUrlPrefix = "data:image/jpeg;base64,";
const reportPhotoDataUrlSchema = z
    .string()
    .max(reportPhotoDataUrlPrefix.length + 4 * Math.ceil(REPORT_PHOTO_MAX_BYTES / 3))
    .superRefine((dataUrl, ctx) => {
    if (!dataUrl.startsWith(reportPhotoDataUrlPrefix)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: "La photo doit être un JPEG." });
        return;
    }
    const encoded = dataUrl.slice(reportPhotoDataUrlPrefix.length);
    if (!encoded.length ||
        encoded.length > 4 * Math.ceil(REPORT_PHOTO_MAX_BYTES / 3) ||
        encoded.length % 4 !== 0 ||
        !/^[A-Za-z0-9+/]+={0,2}$/.test(encoded)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: "La photo est invalide." });
        return;
    }
    const decoded = atob(encoded);
    if (btoa(decoded) !== encoded) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: "La photo est invalide." });
    }
    if (decoded.length > REPORT_PHOTO_MAX_BYTES) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: "La photo dépasse 240 Kio." });
    }
    if (!decoded.startsWith("\xff\xd8\xff") || !decoded.endsWith("\xff\xd9")) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: "La photo doit être un JPEG." });
    }
});
export const reportPhotoMetadataSchema = z.object({
    caption: z
        .string()
        .max(REPORT_PHOTO_CAPTION_MAX_LENGTH, "500 caractères maximum.")
        .refine((caption) => (caption.match(/\r\n|\r|\n/g)?.length ?? 0) <= REPORT_PHOTO_CAPTION_MAX_NEWLINES, "La description ne peut pas dépasser 8 retours à la ligne.")
        .optional(),
});
export const reportPhotoSchema = reportPhotoMetadataSchema.extend({
    dataUrl: reportPhotoDataUrlSchema.optional(),
});
export const reportPhotoInputSchema = reportPhotoMetadataSchema.extend({
    dataUrl: reportPhotoDataUrlSchema,
});
//# sourceMappingURL=reportPhoto.js.map